import Logo from './../img/logob.png'
import { NavLink } from 'react-router-dom';

export default function Menu() {
  return (
    
    <nav className="navbar navbar-expand-lg navbar-dark bg-success shadow-sm fixed-top">
      <div className="container" >
        
        {/* Logo */}
        <NavLink className="navbar-brand d-flex align-items-center" to="/">
          <img src={Logo} alt="Logo" height="40" className="me-2" />
          <span className="fw-bold">COOPMULMAG</span>
        </NavLink>

        {/* Botón hamburguesa */}
        <button 
          className="navbar-toggler" 
          type="button" 
          data-bs-toggle="collapse" 
          data-bs-target="#navbarNav" 
          aria-controls="navbarNav" 
          aria-expanded="false" 
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Menú */}
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto gap-3" style={{ fontSize: '17px' }}>
            
            {/* Elementos normales */}
            <li className="nav-item">
              <NavLink 
                className={({ isActive }) => 
                  `nav-link px-3 ${isActive ? "active fw-bold text-warning border-bottom border-2 border-warning" : "text-white"}`
                }
                to="/"
              >
                Inicio
              </NavLink>
            </li>

            {/* Dropdown Institucional */}
            <li className="nav-item dropdown">
              <button
                className="nav-link dropdown-toggle text-white bg-transparent border-0 px-3"
                type="button"
                id="dropdownInstitucional"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                style={{ fontSize: '17px' }}
              >
                Institucional
              </button>
              <ul className="dropdown-menu dropdown-menu-dark" aria-labelledby="dropdownInstitucional">
                <li>
                  <NavLink className="dropdown-item" to="/institucional/nosotros">
                    Nosotros
                  </NavLink>
                </li>
                <li>
                  <NavLink className="dropdown-item" to="/institucional/ejes-estrategicos">
                    Ejes estratégicos
                  </NavLink>
                </li>
                <li>
                  <NavLink className="dropdown-item" to="/institucional/marco-normativo">
                    Marco Normativo
                  </NavLink>
                </li>
                <li><hr className="dropdown-divider" /></li>
                <li>
                  <NavLink className="dropdown-item" to="/institucional/comunicados">
                    Comunicados
                  </NavLink>
                </li>
                <li>
                  <NavLink className="dropdown-item" to="/institucional/asociados-inhabiles">
                    Asociados inhábiles
                  </NavLink>
                </li>
                <li>
                  <NavLink className="dropdown-item" to="/institucional/tratamiento-datos">
                    Tratamiento de datos
                  </NavLink>
                </li>
              </ul>
            </li>

            {/* Elementos normales restantes */}
            <li className="nav-item">
              <NavLink 
                className={({ isActive }) => 
                  `nav-link px-3 ${isActive ? "active fw-bold text-warning border-bottom border-2 border-warning" : "text-white"}`
                }
                to="/galeria"
              >
                Galería
              </NavLink>
            </li>
            
            <li className="nav-item">
              <NavLink 
                className={({ isActive }) => 
                  `nav-link px-3 ${isActive ? "active fw-bold text-warning border-bottom border-2 border-warning" : "text-white"}`
                }
                to="/contactenos"
              >
                Contáctenos
              </NavLink>
            </li>
            
            <li className="nav-item">
              <NavLink 
                className={({ isActive }) => 
                  `nav-link px-3 ${isActive ? "active fw-bold text-warning border-bottom border-2 border-warning" : "text-white"}`
                }
                to="/vlog"
              >
                Vlog
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}